import Vue from "vue";
import Router from "vue-router";
const routes = require("./router");

Vue.use(Router);

const createRouter = () =>
  new Router({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes,
    base: process.env.BASE_URL
  });

const router = createRouter();

export default router;
